var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "app-container",
    },
    [
      _c("el-page-header", {
        staticStyle: { "margin-bottom": "16px" },
        attrs: { content: "审批详情 #" + _vm.id },
        on: {
          back: function ($event) {
            return _vm.$router.back()
          },
        },
      }),
      _vm.instance
        ? _c(
            "el-row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-card",
                    { attrs: { shadow: "never" } },
                    [
                      _c("div", { staticClass: "detail-title" }, [
                        _vm._v(_vm._s(_vm.instance.title)),
                      ]),
                      _c(
                        "div",
                        { staticClass: "detail-meta" },
                        [
                          _c(
                            "el-tag",
                            { attrs: { size: "small", type: "info" } },
                            [_vm._v(_vm._s(_vm.instance.businessType))]
                          ),
                          _c(
                            "el-tag",
                            {
                              staticStyle: { "margin-left": "6px" },
                              attrs: { size: "small", type: _vm.statusType },
                            },
                            [_vm._v(_vm._s(_vm.statusText))]
                          ),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "12px" } },
                            [_vm._v("编号 #" + _vm._s(_vm.instance.id))]
                          ),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "12px" } },
                            [
                              _vm._v(
                                "提交时间: " + _vm._s(_vm.instance.startTime)
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm.rejectedComment
                        ? _c(
                            "el-alert",
                            {
                              staticStyle: { "margin-top": "12px" },
                              attrs: { type: "error", closable: false },
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c("b", [_vm._v("驳回原因")]),
                                _vm._v(": " + _vm._s(_vm.rejectedComment)),
                              ]),
                            ],
                            2
                          )
                        : _vm._e(),
                      _c("el-divider"),
                      _c("div", { staticClass: "section-title" }, [
                        _vm._v("申请内容"),
                      ]),
                      _vm.bizProduct
                        ? _c(
                            "div",
                            { staticClass: "biz-card" },
                            [
                              _vm.bizProduct.image
                                ? _c("el-image", {
                                    staticClass: "biz-cover",
                                    attrs: {
                                      src: _vm.bizProduct.image,
                                      fit: "cover",
                                      "preview-src-list": [
                                        _vm.bizProduct.image,
                                      ],
                                    },
                                  })
                                : _vm._e(),
                              _c("div", { staticClass: "biz-body" }, [
                                _c(
                                  "div",
                                  { staticClass: "biz-name" },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.bizProduct.name) + " "
                                    ),
                                    _c(
                                      "el-tag",
                                      {
                                        staticStyle: { "margin-left": "6px" },
                                        attrs: {
                                          size: "mini",
                                          effect: "plain",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.auditStatusText(
                                              _vm.bizProduct.auditStatus
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-tag",
                                      {
                                        staticStyle: { "margin-left": "4px" },
                                        attrs: {
                                          size: "mini",
                                          type:
                                            _vm.bizProduct.isShow === 1
                                              ? "success"
                                              : "info",
                                          effect: "plain",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.bizProduct.isShow === 1
                                                ? "已上架"
                                                : "未上架"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm.bizProduct.intro
                                  ? _c("div", { staticClass: "biz-intro" }, [
                                      _vm._v(_vm._s(_vm.bizProduct.intro)),
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "biz-kv" }, [
                                  _c("span", { staticClass: "biz-price" }, [
                                    _vm._v("￥" + _vm._s(_vm.bizProduct.price)),
                                  ]),
                                  _c("span", { staticClass: "biz-tag" }, [
                                    _vm._v(
                                      "库存 " + _vm._s(_vm.bizProduct.stock)
                                    ),
                                  ]),
                                  _vm.bizProduct.cateName
                                    ? _c("span", { staticClass: "biz-tag" }, [
                                        _vm._v(
                                          "分类 " +
                                            _vm._s(_vm.bizProduct.cateName)
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.bizProduct.brandName
                                    ? _c("span", { staticClass: "biz-tag" }, [
                                        _vm._v(
                                          "品牌 " +
                                            _vm._s(_vm.bizProduct.brandName)
                                        ),
                                      ])
                                    : _vm._e(),
                                  _c("span", { staticClass: "biz-tag" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.bizProduct.specType
                                          ? "多规格"
                                          : "单规格"
                                      )
                                    ),
                                  ]),
                                  _c("span", { staticClass: "biz-tag" }, [
                                    _vm._v(
                                      "单位 " +
                                        _vm._s(_vm.bizProduct.unitName || "—")
                                    ),
                                  ]),
                                ]),
                                _vm.skuRows.length
                                  ? _c(
                                      "div",
                                      { staticClass: "biz-sku" },
                                      [
                                        _c(
                                          "el-table",
                                          {
                                            attrs: {
                                              data: _vm.skuRows,
                                              size: "mini",
                                              "max-height": "200",
                                            },
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "序号",
                                                width: "60",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$pageIndex(
                                                              scope
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3594593631
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "规格",
                                                prop: "sku",
                                                "min-width": "140",
                                                "show-overflow-tooltip": "",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "售价",
                                                width: "100",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (ref) {
                                                      var row = ref.row
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "biz-price-sm",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "￥" +
                                                                _vm._s(
                                                                  row.price
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                157569859
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "原价",
                                                prop: "otPrice",
                                                width: "90",
                                              },
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "库存",
                                                prop: "stock",
                                                width: "80",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.formFields.length && _vm.bizProduct
                        ? _c(
                            "el-collapse",
                            { staticClass: "snapshot-collapse" },
                            [
                              _c(
                                "el-collapse-item",
                                { attrs: { name: "snapshot" } },
                                [
                                  _c("template", { slot: "title" }, [
                                    _c(
                                      "span",
                                      { staticClass: "snapshot-title" },
                                      [
                                        _vm._v(
                                          "提交时填写的内容（" +
                                            _vm._s(_vm.formFields.length) +
                                            " 项，可与上方现状对比）"
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "form-grid" },
                                    _vm._l(_vm.formFields, function (f, i) {
                                      return _c(
                                        "div",
                                        {
                                          key: i,
                                          staticClass: "form-item",
                                          class: {
                                            "form-item-wide": _vm.isWide(f),
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "form-label" },
                                            [_vm._v(_vm._s(f.label))]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "form-value" },
                                            [
                                              f.type === "image"
                                                ? [
                                                    _c("el-image", {
                                                      staticClass: "form-image",
                                                      attrs: {
                                                        src: f.value,
                                                        fit: "cover",
                                                        "preview-src-list": [
                                                          f.value,
                                                        ],
                                                      },
                                                    }),
                                                  ]
                                                : f.type === "images"
                                                ? _vm._l(
                                                    _vm.splitImages(f.value),
                                                    function (img, k) {
                                                      return _c("el-image", {
                                                        key: k,
                                                        staticClass:
                                                          "form-image",
                                                        attrs: {
                                                          src: img,
                                                          fit: "cover",
                                                          "preview-src-list":
                                                            _vm.splitImages(
                                                              f.value
                                                            ),
                                                        },
                                                      })
                                                    }
                                                  )
                                                : f.type === "money"
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass: "form-money",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "￥" + _vm._s(f.value)
                                                      ),
                                                    ]
                                                  )
                                                : _c("span", [
                                                    _vm._v(_vm._s(f.value)),
                                                  ]),
                                            ],
                                            2
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm.formFields.length
                        ? _c(
                            "div",
                            { staticClass: "form-grid" },
                            _vm._l(_vm.formFields, function (f, i) {
                              return _c(
                                "div",
                                {
                                  key: i,
                                  staticClass: "form-item",
                                  class: { "form-item-wide": _vm.isWide(f) },
                                },
                                [
                                  _c("div", { staticClass: "form-label" }, [
                                    _vm._v(_vm._s(f.label)),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "form-value" },
                                    [
                                      f.type === "image"
                                        ? [
                                            _c("el-image", {
                                              staticClass: "form-image",
                                              attrs: {
                                                src: f.value,
                                                fit: "cover",
                                                "preview-src-list": [f.value],
                                              },
                                            }),
                                          ]
                                        : f.type === "images"
                                        ? _vm._l(
                                            _vm.splitImages(f.value),
                                            function (img, k) {
                                              return _c("el-image", {
                                                key: k,
                                                staticClass: "form-image",
                                                attrs: {
                                                  src: img,
                                                  fit: "cover",
                                                  "preview-src-list":
                                                    _vm.splitImages(f.value),
                                                },
                                              })
                                            }
                                          )
                                        : f.type === "money"
                                        ? _c(
                                            "span",
                                            { staticClass: "form-money" },
                                            [_vm._v("￥" + _vm._s(f.value))]
                                          )
                                        : _c("span", [_vm._v(_vm._s(f.value))]),
                                    ],
                                    2
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      !_vm.formFields.length &&
                      !_vm.bizProduct &&
                      !_vm.bizLoading
                        ? _c("el-alert", {
                            staticStyle: { "margin-top": "10px" },
                            attrs: {
                              type: "info",
                              closable: false,
                              title: "这类业务还没有接入内容展示",
                              description: "可到对应业务页面查阅原单。",
                            },
                          })
                        : _vm._e(),
                      _vm.bizLoading
                        ? _c("div", {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: true,
                                expression: "true",
                              },
                            ],
                            staticClass: "biz-loading",
                            attrs: {
                              "element-loading-text": "正在读取业务内容...",
                            },
                          })
                        : _vm._e(),
                      _c("el-divider"),
                      _c("div", { staticClass: "section-title" }, [
                        _vm._v("审批流程"),
                      ]),
                      _c(
                        "el-timeline",
                        [
                          _vm._l(_vm.records, function (rec, i) {
                            return _c(
                              "el-timeline-item",
                              {
                                key: i,
                                attrs: {
                                  type: _vm.recType(rec.result),
                                  timestamp: rec.createTime,
                                  placement: "top",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { "font-weight": "500" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.recActionText(rec)) +
                                        " · " +
                                        _vm._s(rec.assigneeName || "(系统)")
                                    ),
                                  ]
                                ),
                                rec.comment
                                  ? _c("div", { staticClass: "tl-comment" }, [
                                      _vm._v(_vm._s(rec.comment)),
                                    ])
                                  : _vm._e(),
                              ]
                            )
                          }),
                          _vm.instance.status === 0
                            ? _c(
                                "el-timeline-item",
                                {
                                  attrs: {
                                    type: "primary",
                                    placement: "top",
                                    timestamp: "处理中",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "font-weight": "500" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.instance.currentTaskName ||
                                              "当前节点"
                                          ) +
                                          " · "
                                      ),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "#409EFF" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.instance
                                                .currentAssigneeName || "待分配"
                                            ) + " 审批中"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-card",
                    { attrs: { shadow: "never" } },
                    [
                      _c("div", { staticClass: "section-title" }, [
                        _vm._v("基本信息"),
                      ]),
                      _c("div", { staticClass: "side-item" }, [
                        _c("span", { staticClass: "k" }, [_vm._v("业务类型")]),
                        _c("span", [_vm._v(_vm._s(_vm.instance.businessType))]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "side-item" },
                        [
                          _c("span", { staticClass: "k" }, [
                            _vm._v("当前节点"),
                          ]),
                          _c(
                            "el-tag",
                            { attrs: { size: "mini", type: "warning" } },
                            [
                              _vm._v(
                                _vm._s(_vm.instance.currentTaskName || "—")
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "side-item" }, [
                        _c("span", { staticClass: "k" }, [_vm._v("审批人")]),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.instance.currentAssigneeName || "—")
                          ),
                        ]),
                      ]),
                      _c("el-divider"),
                      _vm.instance.status === 0
                        ? _c(
                            "el-button",
                            {
                              staticStyle: {
                                width: "100%",
                                "margin-bottom": "8px",
                              },
                              attrs: {
                                type: "danger",
                                plain: "",
                                size: "small",
                              },
                              on: { click: _vm.withdrawInst },
                            },
                            [_vm._v(" 撤回申请 ")]
                          )
                        : _vm._e(),
                      _vm.instance.status === 1 && _vm.instance.result === 1
                        ? _c(
                            "el-button",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { type: "primary", size: "small" },
                              on: { click: _vm.editRejected },
                            },
                            [_vm._v(" 修改后重新提交 ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : !_vm.loading
        ? _c("el-empty", { attrs: { description: "未找到审批详情" } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }